export default __webpack_public_path__ + "static/media/member-sean.6e1d4791.jpg";